import React, { useState } from 'react';
import axios from 'axios';

const AccountDeletionPageRevoAI = () => {
    const [username, setUsername] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [isValid, setIsValid] = useState(false);

    const handleChange = (e) => {
        const value = e.target.value;
        if (value.length <= 6) {
            setUsername(value);
            setIsValid(value.length === 6);
            setMessage('');
        }
    };

    const handleDelete = async () => {
        if (!isValid) {
            setMessage('Username must be exactly 6 characters');
            setMessageType('error');
            return;
        }

        setIsLoading(true);
        setMessage('');

        try {
            await axios.delete('https://home-ai-910dcdaef1e4.herokuapp.com/api/user/delete-by-username', {
                data: { username: username }
            });

            setMessage('Account deleted successfully');
            setMessageType('success');
            setUsername('');
            setIsValid(false);
        } catch (error) {
            if (error.response?.status === 404) {
                setMessage('User not found');
            } else if (error.response?.status === 400) {
                setMessage(error.response?.data?.message || 'Invalid username');
            } else if (error.response?.data?.message) {
                setMessage(error.response.data.message);
            } else {
                setMessage('An error occurred while deleting the account');
            }
            setMessageType('error');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-dark pt-24 pb-16 flex items-center justify-center">
            <div className="bg-dark-card border border-gray-600 p-8 rounded-2xl max-w-md w-full mx-6">
                <h1 className="text-2xl font-custom1 mb-6 text-center text-white">
                    RevoAI Account Deletion
                </h1>
                <p className="text-gray-400 font-custom2 mb-6 text-center text-sm">
                    Enter your 6-character username to permanently delete your RevoAI account and all associated data.
                </p>

                <div className="mb-4">
                    <label className="block text-gray-300 font-custom2 text-sm font-bold mb-2" htmlFor="username">
                        Username (6 characters)
                    </label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={handleChange}
                        placeholder="123456"
                        maxLength={6}
                        className="w-full py-2 px-3 bg-dark border border-gray-600 rounded-lg text-white font-custom2 focus:outline-none focus:border-accent-orange transition-colors"
                        disabled={isLoading}
                    />
                </div>

                <button
                    onClick={handleDelete}
                    disabled={isLoading || !isValid}
                    className={`w-full py-3 px-6 rounded-lg font-custom2 font-semibold text-base transition-all duration-200 ${isLoading || !isValid
                        ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
                        : 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white'
                        }`}
                >
                    {isLoading ? 'Deleting...' : 'Delete Account'}
                </button>

                {message && (
                    <p className={`mt-4 text-center font-custom2 font-medium ${messageType === 'success'
                        ? 'text-green-400'
                        : 'text-red-400'
                        }`}>
                        {message}
                    </p>
                )}

                <div className="mt-6 pt-4 border-t border-gray-700">
                    <p className="text-xs text-gray-500 font-custom2 text-center">
                        Warning: This action cannot be undone. All your data will be permanently deleted.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AccountDeletionPageRevoAI;
